import { TaskForm } from "../../../components/task/TaskForm";

const AddTask = () => {
  return <TaskForm />;
};

export default AddTask;